export default {"otherBookieWrapper":"Kw1Rc","otherBookies":"_1Sjmb"};